import React from 'react';
import style from './style.module.scss';

/** The message of a field that failed validation, under the field. */
export const FieldError = ({ error }: { error?: string }) =>
    error ? <span className={style.field_error}>{error}</span> : null;
